import React, { FC, useEffect } from "react";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Center,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import "react-phone-number-input/style.css";
import { SubmitHandler, useForm } from "react-hook-form";
import $api from "../../http/apiService";
import { toast } from "react-toastify";
import { UserTypeForAdmin } from "./UserList";

type Iprops = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  user: UserTypeForAdmin | undefined;
  isNeedUpdate: number;
  setIsNeedUpdate: any;
  isAddComment: boolean;
  setIsAddComment: any;
};
type IFormInput = {
  comment?: string;
};
const BlockModal = (props: Iprops) => {
  const navigate = useNavigate();

  // React hook form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm<IFormInput>({
    mode: "all",
  });

  //   useEffect(() => {
  //     props.onOpen();
  //   }, []);

  const handleClose = () => {
    props.onClose();
    navigate("/dashboard");
  };

  // Default values hook form initialize
  useEffect(() => {
    reset(props.user);
  }, [props.user]);

  const onSubmitBlockForm: SubmitHandler<IFormInput> = async (data) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (props.isAddComment) {
      const rd = {
        comment: data.comment,
      };
      try {
        const response = await $api.put(
          `/api/admin/User/${props.user?.id}/comment`,
          rd,
          config
        );
        if (response.status === 200) {
          toast(
            `Комментарий для ${props.user?.login} успешно добавлен`
          );
        }
      } catch (e) {
        console.error("Ошибка добавления комментария", e);
        toast.error("Ошибка добавления комментария");
      } finally {
        // props.setIsAddComment(false);
        props.onClose();
      }
    } else if (!props.user?.isBlocked) {
      const rd = {
        comment: data.comment,
      };
      try {
        const response = await $api.put(
          `/api/admin/User/${props.user?.id}/block`,
          rd,
          config
        );
        if (response.status === 200) {
          toast(
            `Пользователь ${props.user?.login} успешно заблокирован`
          );
        }
      } catch (e) {
        console.error("Ошибка блокировки", e);
        toast.error("Ошибка блокировки");
      } finally {
        props.onClose();
      }
    } else {
      try {
        const response = await $api.put(
          `/api/admin/User/${props.user?.id}/unblock`,
          config
        );
        if (response.status === 200) {
          toast(
            `Пользователь ${props.user?.login} успешно разблокирован`
          );
        }
      } catch (e) {
        console.error("Ошибка разблокировки", e);
        toast.error("Ошибка разблокировки");
      } finally {
        props.onClose();
      }
    }
    props.setIsNeedUpdate(props.isNeedUpdate + 1);
    props.setIsAddComment(false);

    // reset();
  };

  const getTitle = () => {
    if (props.isAddComment) {
      return `Добавить комментарий для пользователя ${props?.user?.name}`;
    } else if (props.user?.isBlocked) {
      return `Разблокировать пользователя ${props?.user?.name}`;
    } else return `Блокировать пользователя ${props?.user?.name}`;
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      closeOnOverlayClick={false}
      motionPreset="slideInBottom"
      size={"5xl"}
      isCentered
    >
      <ModalOverlay
        backdropBlur="5px"
        bg="blackAlpha.300"
        backdropFilter="blur(10px) "
      />
      <ModalContent>
        <ModalHeader fontSize={24} color="blue.500" fontWeight="bold">
          <Center>
            {/* {props.user?.isBlocked
              ? `Разблокировать пользователя ${props?.user?.name}`
              : `Блокировать пользователя ${props?.user?.name}`}{" "} */}
            {getTitle()}
          </Center>
        </ModalHeader>
        <form onSubmit={handleSubmit(onSubmitBlockForm)}>
          <ModalBody fontSize={16}>
            <Text fontSize={12} color="gray.500" mt={8}>
              Комментарий
            </Text>
            <Textarea
              placeholder="Комментарий"
              size="lg"
              readOnly={props.user?.isBlocked ? true : false}
              {...register("comment", {
                required: "Поле обязательно к заполнению",
              })}
            />
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={handleSubmit(onSubmitBlockForm)}
              isDisabled={!isValid}
              type="submit"
              // colorScheme="blue"
              colorScheme="facebook"
              ml={10}
              width={60}
              height={16}
              fontSize="2xl"
              boxShadow="dark-lg"
            >
              Сохранить
            </Button>
            <Button
              colorScheme="twitter"
              ml={10}
              width={60}
              height={16}
              fontSize="2xl"
              boxShadow="dark-lg"
              onClick={() => {
                props.setIsAddComment(false);
                handleClose();
              }}
            >
              Закрыть
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default BlockModal;
